export default __webpack_public_path__ + "static/media/arrow-down-blue.79f4a4fe.svg";